//@vendors
const Immutable = require('immutable');
const get = require('lodash/object/get');

const { handleActions } = require('redux-actions');
//@actions
const { simpleActions } = require('../../actions/commons/contractInit');
const { parseSpanishNumberToFloat } = require('utilities/currencyHelper');
const { EURO_TEXT } = require('constants/index');

const setInitialState = () => Immutable.fromJS({
    initAPIFlag: false,
    mailAPIFlag: false,
    checkboxFlag: false,
    btnFlag: false,
    selectedTerm: 0,
    currency: EURO_TEXT,
    propositionNumber: '',
    propositionYear: '',
    contractNumber: '',
    tin: 0,
    tae: 0,
    isFetchingINEDocument: false,
    errorEasyLoanTypecIneDocument: false,
    fileEasyLoanTypecIneDocument: null,
    fileEasyLoanTypecIneDocumentId: null,
    fileEasyLoanPolicyDocument: null,
    fileEasyLoanPolicyDocumentId: null,
    errorEasyLoanPolicyDocument: false,
    isFetchingPolicyDocuments: false,
    isFetchingDocuments: !__CONTACT_CENTER__, // We don´t fetch documents in CC - the PDF viewer is hidden
    errorDocuments: false,
    isFetchingPrintDocuments: false,
    error: true,
    easyLoanTypecIExpedient: false,
    errorPolicy: false,
    hasEasyLoanSuccess: null,

});
const processOpeningCommission = (openingCommissionPercentage, openingCommissionMin, loanAmount) => {

    let openingCommissionAmount = loanAmount * openingCommissionPercentage / 100;

    if (openingCommissionMin > openingCommissionAmount) {
        openingCommissionAmount = openingCommissionMin;
    }

    return {
        minimum: openingCommissionMin,
        percentage: openingCommissionPercentage,
        amount: openingCommissionAmount,
        showPercentajeCommission: !(openingCommissionMin !== 0 && openingCommissionPercentage === 0),
        showMinCommission: openingCommissionMin !== 0
    };
};

const initialize = (state, segmentedLoan) => {
    const rawAmountMax = get(segmentedLoan, 'importeMaximo') || 0;
    const rawAmountMin = get(segmentedLoan, 'importeMinimo') || 0;
    const rawQuotaLimit = get(segmentedLoan, 'limiteCuota') || 0;
    const rawOpeningCommission = get(segmentedLoan, 'comisionApertura') || 0;
    const rawOpeningCommissionMin = get(segmentedLoan, 'comisionAperturaMin') || 0;
    const maxTerm = parseInt(get(segmentedLoan, 'plazoMaximo')) || 0;
    const defaultTermMin = parseInt(get(segmentedLoan, 'plazoMinimo')) || 0;

    const openingCommissionData = parseSpanishNumberToFloat(rawOpeningCommission);
    const openingCommissionMin = parseSpanishNumberToFloat(rawOpeningCommissionMin);
    const maxAmount = parseSpanishNumberToFloat(rawAmountMax);
    const minAmount = parseSpanishNumberToFloat(rawAmountMin);
    const maxAmountError = minAmount > maxAmount;
    const selectedAmount = state.get('selectedAmount') !== 0 ? state.get('selectedAmount'): maxAmount;
    const selectedTerm = state.get('selectedTerm') !== 0 ? state.get('selectedTerm') : maxTerm;

    return state.merge({
        currency: get(segmentedLoan, 'divisa', EURO_TEXT),
        maxAmount,
        minAmount,
        maxAmountError,
        maxTerm,
        minTerm: defaultTermMin,
        minTae: get(segmentedLoan, 'minTae', 0),
        maxTae: get(segmentedLoan, 'maxTae', 0),
        defaultTermMin,
        quotaLimit: parseSpanishNumberToFloat(rawQuotaLimit),
        selectedAmount,
        selectedTerm,
        tin: parseSpanishNumberToFloat(get(segmentedLoan, 'tipoNominal')) || 0,
        type: get(segmentedLoan, 'tipo') || '',
        subtype: get(segmentedLoan, 'subtipo') || '',
        standard: get(segmentedLoan, 'standard') || '',
        aniversaryType: get(segmentedLoan, 'tipoPagoAniversario') || '',
        aniversarySubtype: get(segmentedLoan, 'subtipoPagoAniversario') || '',
        aniversaryStandard: get(segmentedLoan, 'erPagoAniversario') || '',
        openingCommission: processOpeningCommission(openingCommissionData, openingCommissionMin, maxAmount),
        stepReady: true,
        isFetching: false,
        hasEasyLoanSuccess: true,
        fetchingProposition: false,

    });
};

const mapPropositionNumber = (state, action) => {
    return state.merge({
        ...action.payload.response,
        fetchingProposition: false
    });
}
const contractInitReducer = handleActions(
    {
        [simpleActions.setInitApiFlag]: (state, action) =>
            state.merge({
                initAPIFlag: action.payload.initAPIFlag,
                mailAPIFlag: action.payload.mailAPIFlag,
                checkboxFlag: action.payload.checkboxFlag,
                btnFlag: action.payload.btnFlag
            }),
        [simpleActions.contractEasyLoanGetInitProposition]: state =>
            state.set('fetchingProposition', true),
        [simpleActions.contractEasyLoanGetPropositionError]: state =>
            state.merge({
                fetchingProposition: false,
                error: true
            }),
        [simpleActions.contractEasyLoanGetPropositionSuccess]: (state, action) =>
            mapPropositionNumber(state, action),
        [simpleActions.contractEasyLoanInitLoading]: state =>
            state.merge({
                isEasyLoanEmailInitError: false,
                isEasyLoanEmailInitSuccess: false
            }),
        [simpleActions.contractEasyLoanInitOneSuccess]: (state, action) =>
            state.merge({
                isEasyLoanEmailInitError: false,
                isEasyLoanEmailInitSuccess: true,
                operationProcessIdINE: action.payload.operationProcessIdINE
            }),
        [simpleActions.getEasyLoanIneDocument]: (state) =>
            state.merge({
                isFetchingINEDocument: true,
                errorEasyLoanTypecIneDocument: false
            }),

        [simpleActions.getEasyLoanInitPolicyDocument]: (state) =>
            state.merge({
                isFetchingPolicyDocuments: true,
                errorEasyLoanPolicyDocument: false
            }),
        [simpleActions.getEasyLoanExpedientSuccess]: (state, action) =>
            state.merge({
                easyLoanTypecIExpedient: true
            }),
        [simpleActions.contractEasyLoanResetExpedient]: (state, action) =>
            state.merge({
                easyLoanTypecIExpedient: false
            }),
        [simpleActions.getEasyLoanInitIneDocumentSuccess]: (state, action) =>
            state.merge({
                fileEasyLoanTypecIneDocument: `data:application/pdf;base64,${action.payload.base64}`,
                fileEasyLoanTypecIneDocumentId: action.payload.documentId,
                errorEasyLoanTypecIneDocument: false,
                operationProcessId: action.payload.operationProcessId,
                isFetchingINEDocument: false,
            }),
        [simpleActions.getEasyLoanIneDocumentError]: (state) =>
            state.merge({
                errorEasyLoanTypecIneDocument: true,
                isFetchingINEDocument: false
            }),
        [simpleActions.getEasyLoanInitPolicyDocumentSuccess]: (state, action) =>
            state.merge({
                fileEasyLoanPolicyDocument: `data:application/pdf;base64,${action.payload.base64}`,
                fileEasyLoanPolicyDocumentId: action.payload.documentId,
                errorEasyLoanPolicyDocument: false,
                isFetchingPolicyDocuments: false
            }),

        [simpleActions.getEasyLoanInitPolicyDocumentError]: (state) =>
            state.merge({
                errorEasyLoanPolicyDocument: true,
                isFetchingPolicyDocuments: false
            }),
        [simpleActions.contractEasyLoanInitError]: state =>
            state.merge({
                isEasyLoanEmailInitError: true,
                isEasyLoanEmailInitSuccess: false
            }),
        [simpleActions.contractEasyLoanInitWillLeave]: (state) =>
            state.mergeDeep(setInitialState()),

        [simpleActions.contractEasyLoanInitGetPropositionError]: state =>
            state.merge({
                fetchingProposition: false,
                error: true,
                errorPolicy: true
            }),
        [simpleActions.contractEasyLoanPreFillSuccess]: (state, action) =>
            initialize(state, action.payload),
    },
    setInitialState()
);

module.exports = contractInitReducer;
module.exports.setInitialState = setInitialState;